
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { showModal, showNestedModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import ReactPDF, { PDFViewer, PDFDownloadLink, pdf } from '@react-pdf/renderer';
import Btn from "../../shared/button/Btn"
import { clearCheckedData, sendMail } from "../../../features/joblist/jobListSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import TasimaSenediPDF from "../../pdf/TasımaSenediPDF"
import getCurrentDate from "../../../helper/getCurrentDate"
import getCurrentTime from "../../../helper/getCurrentTime"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import JobListMektupSender from "./JobListMektupSender"
import JobListPDFViewer from "./JobListPDFViewer"
const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1500px;
        max-height: 750px;
        overflow: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            width: 100%;
            border-radius: 10px;
            margin-top: 20px;
        }


    }
`

const ShowMektupModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)


    const { lockScroll, unlockScroll } = useScrollLock();


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Taşıma Senedi"}/>
            <div className="content">
                <JobListPDFViewer/>
            </div>
            <JobListMektupSender/>

        </div>
    </ModalContainer>
  )
}



export default ShowMektupModal